<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                :class="mode ? 'content__titleday' : 'content__titlenight'"
                class="content-title d-flex align-center mr-2"
              >
                {{ $t("message.late_to_works") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    v-model="filterForm.search"
                    :class="mode ? 'input__day' : 'input__night'"
                    :icon="'el-icon-search'"
                    class="mr-2"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="flex-style text-right">
            <div class="ml-2" style="float: right">
              <crm-create-and-column-settings
                :permission="$options.name"
                @c-create="drawerCreate = true"
                :class="mode ? 'button__settingsday' : 'button__settingsnight'"
                :columns="columns"
                @c-change="updateColumn"
                :v_can_create="'lateToWorks.create'"
              >
              </crm-create-and-column-settings>
            </div>

            <export-excel
              v-can="'lateToWorks.excel'"
              class="btn excel_btn"
              style="display:inline-flex"
              :data="list"
              @fetch="controlExcelData()"
              :fields="excel_fields"
              :worksheet="$t('message.late_to_works')"
              :name="$t('message.late_to_works')"
            >
              <el-button size="mini">
                <i class="el-icon-document-delete"></i>
                {{ $t("message.excel") }}
              </el-button>
            </export-excel>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->
      <div class="card-table-header table-crm-smart">
        <table
          class="table-my-code table-bordered"
          v-loading="loadingData"
          :class="mode ? 'table__myday' : 'table__mynight'"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.staff.show">
                {{ columns.staff.title }}
              </th>
              <th v-if="columns.reason.show">
                {{ columns.reason.title }}
              </th>
              <th v-if="columns.comment.show">
                {{ columns.comment.title }}
              </th>
              <th v-if="columns.coming_date_time.show">
                {{ columns.coming_date_time.title }}
              </th>

              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.staff.show">
                <select-staff
                  :id="filterForm.staff_id"
                  :size="'mini'"
                  :class="mode ? 'input__day' : 'input__night'"
                  v-model="filterForm.staff_id"
                ></select-staff>
              </th>
              <th v-if="columns.reason.show">
                <el-select
                  clearable
                  v-model="filterForm.reason_id"
                  :placeholder="$t('message.reason')"
                  class="w-100"
                  :class="mode ? 'input__day' : 'input__night'"
                  :size="'mini'"
                  popper-class="my-data-khan"
                >
                  <el-option
                    v-for="(reason, index) in reasons"
                    :key="'guestreason-' + index"
                    :label="reason.name"
                    :value="reason.id"
                  ></el-option>
                </el-select>
              </th>
              <th v-if="columns.comment.show">
                <crm-input
                  size="mini"
                  :inputValue="filterForm.comment"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.comment"
                  :placeholder="columns.comment.title"
                ></crm-input>
              </th>

              <th v-if="columns.coming_date_time.show">
                <crm-input
                  :disabled="true"
                  size="mini"
                  :inputValue="filterForm.coming_date_time"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.coming_date_time"
                  :placeholder="columns.coming_date_time.title"
                ></crm-input>
              </th>

              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                  :date="filterForm.created_at"
                  size="mini"
                >
                </crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="guest in list"
              :key="guest.id"
              class="cursor-pointer"
              @dblclick="edit(guest)"
            >
              <td v-if="columns.id.show">{{ guest.id }}</td>
              <td v-if="columns.staff.show">
                {{ guest.staff ? guest.staff.name : "" }}
                {{ guest.staff ? guest.staff.last_name : "" }}
              </td>
              <td v-if="columns.reason.show">
                {{ guest.reason ? guest.reason.name : "" }}
              </td>
              <td v-if="columns.comment.show">
                {{ guest.comment }}
              </td>

              <td v-if="columns.coming_date_time.show">
                {{ guest.coming_date_time }}
              </td>
              <td v-if="columns.created_at.show">{{ guest.created_at }}</td>
              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="guest"
                  :actions="actions"
                  :permissionShow="'lateToWorks.update'"
                  :permissionDestroy="'lateToWorks.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>
    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="drawerUpdate"
      size="70%"
      ref="drawerUpdate"
      @opened="drawerOpened('drawerUpdateChild')"
      @closed="drawerClosed('drawerUpdateChild')"
    >
      <crm-update
        :selectedItem="selectedItem"
        ref="drawerUpdateChild"
        drawer="drawerUpdate"
      ></crm-update>
    </el-drawer>
    <div class="app-modal app-modal__full">
      <el-drawer
        :with-header="false"
        :visible.sync="drawerCreate"
        size="70%"
        ref="drawerCreate"
        @opened="drawerOpened('drawerCreateChild')"
        @closed="drawerClosed('drawerCreateChild')"
      >
        <crm-create ref="drawerCreateChild" drawer="drawerCreate"></crm-create>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import list from "@/utils/mixins/list";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  mixins: [list],
  name: "LateToWorkController",
  components: {
    CrmCreate,
    CrmUpdate
  },
  data() {
    return {
      drawer: false,
      currentPage2: 5,
      checkList: [],
      form: {},
      sarcheBlocks: ""
    };
  },
  mounted() {
    this.reasonsAction();
  },
  computed: {
    ...mapGetters({
      list: "lateToWorks/list",
      reasons: "lateToWorks/reasons",
      columns: "lateToWorks/columns",
      pagination: "lateToWorks/pagination",
      statues: "lateToWorks/statues",
      filter: "lateToWorks/filter",
      sort: "lateToWorks/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["edit", "delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "lateToWorks/index",
      setPagination: "lateToWorks/setPagination",
      updateSort: "lateToWorks/updateSort",
      updateFilter: "lateToWorks/updateFilter",
      updateColumn: "lateToWorks/updateColumn",
      updatePagination: "lateToWorks/updatePagination",
      show: "lateToWorks/show",
      empty: "lateToWorks/empty",
      delete: "lateToWorks/destroy",
      reasonsAction: "lateToWorks/reasons",
      refreshData: "lateToWorks/refreshData"
    }),
    openDrawer() {
      this.appModal = !this.appModal;
    },
    controlExcelData() {
      this.excel_fields = {};
      for (let key in this.columns) {
        if (this.columns.hasOwnProperty(key)) {
          let column = this.columns[key];
          if (column.show && column.column != "settings") {
            switch (column.column) {
              case "staff":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.staff
                      ? item.staff.name + " " + item.staff.last_name
                      : "";
                  }
                };
                break;
              case "reason":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.reason ? item.reason.name : "";
                  }
                };
                break;
              default:
                this.excel_fields[column.title] = column.column;
                break;
            }
          }
        }
      }
    }
  }
};
</script>
